import { useDispatch, useSelector } from "react-redux";
import {
  changeMatchState,
  changeUserMode,
} from "../redux/slices/userModeSlice";
import { setBalance } from "../redux/slices/userSlice";
import { setGameData, resetGameData } from "../redux/slices/gameDataSlice";
import { duringPlay, inPlay } from "../redux/types/userModeTypes";
import sessionApi from "../api/sessionApi";
const useStartGame = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const startGame = async (betAmount, minesAmount) => {
    const res = await sessionApi(betAmount, minesAmount, user.uid ?? null);
    if (res !== null && res !== undefined) {
      dispatch(resetGameData());
      dispatch(changeUserMode(duringPlay));
      dispatch(changeMatchState(inPlay));
      dispatch(setBalance(res.currentBalance));
      dispatch(setGameData(res));
    }
  };

  return startGame;
};

export default useStartGame;
